import styled from '@emotion/styled'

export const StyleModalWrapper = styled.div<any>`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  z-index: 1111;
`

export const StyleModalOverlay = styled.div<any>`
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: 0.5 ease-in;
`

export const StyleModalCard = styled.div<any>`
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 8px;
  position: relative;
  @media (max-width: 640px) {
    width: 100%;
  }
  width: ${(props) =>
    typeof props.size == 'string' ? props.size : `${props.size}px}`};
`

export const StyleModalCardHeader = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  padding: 15px 20px;
`
export const StyleModalCardTitle = styled.h2<any>`
  font-size: 16px;
  color: ${(props: any) => props.theme.colors.primary};
`
export const StyleModalCardBody = styled.div<any>`
  padding: 15px 20px;
`

export const StyleCrossIconWrapper = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  width: 25px;
  height: 25px;
  border-radius: 50%;
  position: absolute;
  right: -10px;
  top: -10px;
  display: flex;
  align-items: center;
  justify-content: center;
`
